import BaseValidator from "./BaseValidator";

// Default isValid: at least one non-space was found
// Default isValidAndOptional allow everything
const defaultTextValidator = Object.create(BaseValidator);

defaultTextValidator.validateAgainstRegex = /\S/;
defaultTextValidator.isValidAndOptional = () => true;

export default defaultTextValidator.init();
